import { EDealType } from '../repositories/favorites/v1/add-offers-in-folders';
export var mapDealType = function mapDealType(dealType) {
  var dealTypes = {
    rent: EDealType.Rent,
    sale: EDealType.Sale
  };
  return dealTypes[dealType];
};